// TB-080: where a 401 (expired or invalid session) sends the user.
// It always went to the patient login, so a doctor or an establishment whose
// token expired landed on the wrong portal. The party comes from the stored
// user (read before the session is cleared), else from the current path.
import { PATIENT_AUTH_ROUTES, DOCTOR_AUTH_ROUTES } from '@/components/auth/authParty'

const DOCTOR_ROLES = new Set(['provider', 'estProvider', 'doctor'])

/** 'patient' | 'doctor' | 'establishment' for a stored role and current path. */
export function partyFor (role, path) {
  if (role === 'establishment') return 'establishment'
  if (DOCTOR_ROLES.has(role)) return 'doctor'
  if (role === 'patient' || role === 'user') return 'patient'
  return typeof path === 'string' && /^\/doctor(\/|$)/.test(path) ? 'doctor' : 'patient'
}

/** Login location for a party (router push target). */
export function loginLocationFor (party) {
  if (party === 'establishment') return { path: '/doctor/login', query: { party: 'establishment' } }
  if (party === 'doctor') return { path: '/doctor/login' }
  return { path: '/login' }
}

/**
 * True on the sign-in / sign-up / reset pages. A 401 there is a wrong
 * password or an expired OTP: the page shows it, nothing is cleared and
 * there is no redirect (that used to bounce the doctor login to /login).
 */
export function isAuthRoute (route) {
  const name = route && typeof route.name === 'string' ? route.name : ''
  return PATIENT_AUTH_ROUTES.has(name) || DOCTOR_AUTH_ROUTES.has(name)
}

export function storedRole (storage) {
  for (const key of ['user', 'userInfo']) {
    try {
      const u = JSON.parse(storage.getItem(key))
      if (u && (u.userRole || u.role)) return u.userRole || u.role
    } catch (e) { /* unreadable: try the next key */ }
  }
  return null
}

/**
 * Login location for a 401, or null when no redirect should happen.
 * route: the current route ({ name, path }).
 */
export function sessionExpiredTarget (route, role) {
  if (isAuthRoute(route)) return null
  const target = loginLocationFor(partyFor(role, route && route.path))
  if (route && route.path === target.path) return null
  return target
}
